export default __webpack_public_path__ + "static/media/WhatsApp_Logo_2.9e6b08d6.png";